import { useMutation } from "react-query";
import downloadVerifyInvoices from "../services/downloadVerifyInvoices";

function useDownloadVerifyInvoices() {
  return useMutation(["download-verify-invoices"], downloadVerifyInvoices);
}

export default useDownloadVerifyInvoices;
